export enum CreditRange {
  LessThan550 = 'LessThan550',
  Between550and659 = 'Between550and659',
  Between660and750 = 'Between660and750',
  MoreThan750 = 'MoreThan750',
  NotSure = 'NotSure',
}
